
import { useState } from 'react';
import { Customer } from '../../components/customer-selector/types';

export const useOrderFormState = () => {
  const [customerId, setCustomerId] = useState('');
  const [customerName, setCustomerName] = useState('Client par défaut');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [customerCountry, setCustomerCountry] = useState('');
  const [customerRegion, setCustomerRegion] = useState('');
  const [customerMunicipality, setCustomerMunicipality] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [orderNumber, setOrderNumber] = useState('');
  const [orderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]);
  const [shippingAddress, setShippingAddress] = useState('');
  const [notes, setNotes] = useState('');
  
  return {
    customerId, 
    setCustomerId,
    customerName, 
    setCustomerName,
    customerEmail,
    setCustomerEmail,
    customerPhone,
    setCustomerPhone,
    customerCountry,
    setCustomerCountry,
    customerRegion,
    setCustomerRegion,
    customerMunicipality,
    setCustomerMunicipality,
    selectedCustomer, 
    setSelectedCustomer,
    orderNumber, 
    setOrderNumber,
    orderDate, 
    setOrderDate,
    shippingAddress, 
    setShippingAddress,
    notes, 
    setNotes
  };
};
